var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoughupsLogoDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "206px",
    height: "200px",
    viewBox: "0 0 206 200",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "roughups_logo_dark") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "roughups_logo_dark"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#2D3237",
    strokeWidth: 10,
    fillRule: "nonzero",
    x: 17,
    y: 17,
    width: 168,
    height: 168
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#0091FF",
    fillRule: "nonzero",
    x: 0,
    y: 0,
    width: 40,
    height: 40,
    rx: 20
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#0091FF",
    fillRule: "nonzero",
    x: 166,
    y: 0,
    width: 40,
    height: 40,
    rx: 20
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#0091FF",
    fillRule: "nonzero",
    x: 166,
    y: 160,
    width: 40,
    height: 40,
    rx: 20
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#0091FF",
    fillRule: "nonzero",
    x: 0,
    y: 160,
    width: 40,
    height: 40,
    rx: 20
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 8,
    points: "44 110.517382 59.25 92 74.5 110.517382 89.75 92 105 110.517382 120.25 92 135.5 110.517382 150.75 92 166 110.517382"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoughupsLogoDark);
export default __webpack_public_path__ + "static/media/roughups_logo_dark.788012908ec9c6ff13fdbb2f9bf65cba.svg";
export { ForwardRef as ReactComponent };